module.exports = __webpack_public_path__ + "static/media/Barlow-Regular.8377a297.ttf";